import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  Validators,
  FormGroup,
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upload-credit-note',
  templateUrl: './upload-credit-note.component.html',
  styleUrls: ['./upload-credit-note.component.scss'],
})
export class UploadCreditNoteComponent implements OnInit {
  loading = false;
  fileTypeError = false;
  signatureError = false;
  validateSignature = false;
  validateEinvoice = false;

  creditNoteData = new FormGroup({
    documentType: new FormControl('', Validators.required),
    poFile: new FormControl('', Validators.required),
  });

  constructor(private router: Router) {}

  selectFile(event: any) {
    const fileSelected = event.target.files[0];
    console.log('This function works ' + fileSelected);
    this.loading = true;
    this.validateSignature = true;
    setTimeout(() => {
      this.router.navigateByUrl('/validate-credit-note');
    }, 4000);
  }

  onValidatePo() {}

  ngOnInit(): void {}
}
